(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.mp-rv:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function carousels(root){
    (root||document).querySelectorAll('[data-mp-car]').forEach(function(c){
      if(c.dataset.ready)return;c.dataset.ready=1;
      var t=c.querySelector('.mp-car__track');
      c.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){
        var card=t.firstElementChild;var w=card?card.getBoundingClientRect().width+16:300;
        t.scrollBy({left:w*(+b.dataset.dir),behavior:'smooth'});
      })});
    });
  }
  function swatches(root){
    (root||document).querySelectorAll('[data-mp-pc]').forEach(function(s){
      if(s.dataset.ready)return;s.dataset.ready=1;
      var btns=s.querySelectorAll('.mp-sw button'),sz=s.querySelectorAll('.mp-sz button'),imgs=s.querySelectorAll('.mp-pc__stage img'),lbl=s.querySelector('[data-mp-color]'),slbl=s.querySelector('[data-mp-size-label]'),cta=s.querySelector('[data-mp-cta]'),pr=s.querySelector('[data-mp-price]'),cp=s.querySelector('[data-mp-cmp]');
      var map={};try{map=JSON.parse(s.querySelector('[data-mp-variants]').textContent)}catch(e){}
      var color=(s.querySelector('.mp-sw button.is-on')||{}).dataset?s.querySelector('.mp-sw button.is-on').dataset.name:'',size='90';
      function upd(){var v=map[size+'|'+color];if(!v)return;if(cta)cta.href=v.url;if(pr)pr.textContent=v.price;if(cp)cp.textContent=v.cmp}
      btns.forEach(function(b,i){b.addEventListener('click',function(){
        btns.forEach(function(x){x.classList.remove('is-on');x.setAttribute('aria-pressed','false')});b.classList.add('is-on');b.setAttribute('aria-pressed','true');
        imgs.forEach(function(im){im.classList.toggle('is-on',im.dataset.i==i)});
        color=b.dataset.name;if(lbl)lbl.textContent=color;upd();
      })});
      sz.forEach(function(b){b.addEventListener('click',function(){
        sz.forEach(function(x){x.classList.remove('is-on');x.setAttribute('aria-pressed','false')});b.classList.add('is-on');b.setAttribute('aria-pressed','true');
        size=b.dataset.size;if(slbl)slbl.textContent=b.textContent;upd();
      })});
      upd();
    });
  }
  function specs(root){
    (root||document).querySelectorAll('[data-mp-specs]').forEach(function(s){
      if(s.dataset.ready)return;s.dataset.ready=1;
      var b=s.querySelectorAll('[data-spec-size]');
      b.forEach(function(x){x.addEventListener('click',function(){
        b.forEach(function(y){y.classList.toggle('is-on',y===x);y.setAttribute('aria-pressed',y===x)});
        s.setAttribute('data-size',x.dataset.specSize);
      })});
    });
  }
  function videos(root){
    var vids=(root||document).querySelectorAll('video[data-mp-lazy]');
    function load(v){if(v.dataset.loaded)return;v.dataset.loaded=1;v.querySelectorAll('source[data-src]').forEach(function(s){s.src=s.dataset.src});v.muted=true;v.load();}
    function play(v){load(v);v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});}
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){en.forEach(function(e){var v=e.target;if(e.isIntersecting){if(!v.dataset.userPaused)play(v)}else if(v.dataset.loaded){v.pause()}})},{rootMargin:'200px 0px'});
      vids.forEach(function(v){io.observe(v)});
    } else vids.forEach(play);
    (root||document).querySelectorAll('[data-mp-vtoggle]').forEach(function(btn){
      if(btn.dataset.ready)return;btn.dataset.ready=1;
      var v=btn.parentNode.querySelector('video');if(!v)return;
      btn.addEventListener('click',function(){if(v.paused){v.dataset.userPaused='';play(v);btn.setAttribute('aria-label','Video pausieren')}else{v.pause();v.dataset.userPaused=1;btn.setAttribute('aria-label','Video abspielen')}});
    });
  }
  function gallery(){
    var mw=document.querySelector('.product--columns_mix .product__media-wrapper'), info=document.querySelector('.product__info-wrapper');
    if(!mw||!info||mw.dataset.mp)return; mw.dataset.mp=1;
    var g=mw.querySelector('media-gallery')||mw.firstElementChild; g.classList.add('mp-gal');
    var list=g.querySelector('.splide__gallery-columns_mix'); if(!list)return;
    var slides=[].slice.call(list.querySelectorAll(':scope > .splide__slide'));
    var carousel=g.querySelector('gallery-carousel');
    function desk(){return window.innerWidth>=990}
    function layout(activeVariantId){
      var vis=[];
      slides.forEach(function(sl){sl.classList.remove('mp-big','mp-first');
        if(sl.hasAttribute('data-mp-variant')){ var on=activeVariantId&&sl.dataset.mediaId==String(activeVariantId); sl.classList.toggle('mp-hide',desk()&&!on); if(on) sl.classList.add('mp-first'); }
        else sl.classList.remove('mp-hide');
      });
      var first=list.querySelector('.mp-first'); if(first&&desk()) vis.push(first);
      slides.forEach(function(sl){ if(!sl.classList.contains('mp-hide')&&sl!==first) vis.push(sl) });
      vis.forEach(function(sl,i){ sl.style.order=desk()?i:''; if(desk()&&i%3===0) sl.classList.add('mp-big') });
    }
    var cur=(g.querySelector('[data-mp-variant].is-active')||{}).dataset; cur=cur?cur.mediaId:null;
    if(!cur){var fv=list.querySelector('[data-mp-variant]'); cur=fv&&fv.dataset.mediaId}
    layout(cur);
    // Variantenwechsel: Bild oben ersetzen statt runterscrollen
    var GC=customElements.get('gallery-carousel');
    if(GC&&!GC.prototype._mp){GC.prototype._mp=1; var orig=GC.prototype.updateCarouselImages;
      GC.prototype.updateCarouselImages=function(id){ if(desk()&&this.closest('.mp-gal')){ cur=String(id); layout(cur); fit(); var top=mw.getBoundingClientRect().top; if(top<0) mw.scrollIntoView({behavior:'smooth',block:'start'}); return;} return orig.call(this,id) };
    }
    var vmap={}; try{vmap=JSON.parse(g.querySelector('[data-mp-vmap]').textContent)}catch(e){}
    function sync(){ var inp=document.querySelector('.product__info-wrapper input[name="id"], .product__info-wrapper select[name="id"]'); var mid=inp&&vmap[inp.value]; if(mid&&mid!==cur){cur=mid;layout(cur);fit()} }
    document.addEventListener('change',function(){setTimeout(sync,50);setTimeout(sync,400)},true);
    var n=slides.filter(function(s){return !s.hasAttribute('data-mp-variant')}).length+1;
    var btn=document.createElement('button'); btn.type='button'; btn.className='mp-btn mp-btn--light mp-gal__more'; btn.style.boxShadow='0 6px 20px -8px rgba(0,0,0,.3)';
    g.appendChild(btn); var open=false;
    function fit(){
      if(!desk()||open){g.style.maxHeight='';g.classList.remove('is-capped');btn.textContent=open?'Weniger anzeigen':'';g.classList.toggle('has-more',open&&desk());return}
      var pi=info.querySelector('product-info')||info; var h=Math.max(pi.scrollHeight,700); g.style.maxHeight='';
      if(g.scrollHeight>h+120){g.style.maxHeight=h+'px';g.classList.add('is-capped','has-more');btn.textContent='Alle '+n+' Bilder anzeigen'}
      else{g.classList.remove('is-capped','has-more')}
    }
    btn.addEventListener('click',function(){open=!open;fit();if(!open)mw.scrollIntoView({behavior:'smooth'})});
    fit(); window.addEventListener('resize',function(){layout(cur);fit()}); window.addEventListener('load',fit); setTimeout(fit,1500);
  }
  function masseModal(){
    if(document.documentElement.dataset.mpModal)return; document.documentElement.dataset.mpModal=1;
    document.addEventListener('click',function(e){
      var a=e.target.closest('a[href="#masse"]'); if(!a||!a.closest('.product__info-wrapper'))return;
      var src=document.getElementById('masse'); if(!src)return; e.preventDefault();
      var m=document.createElement('div'); m.className='mp-modal'; m.setAttribute('role','dialog'); m.setAttribute('aria-modal','true');
      var box=document.createElement('div'); box.className='mp-modal__box';
      var c=src.cloneNode(true); c.removeAttribute('id'); c.classList.remove('mp-pad'); c.querySelectorAll('[data-ready]').forEach(function(x){x.removeAttribute('data-ready')}); c.removeAttribute('data-ready');
      c.querySelectorAll('.mp-rv').forEach(function(x){x.classList.add('is-in')});
      var x=document.createElement('button'); x.type='button'; x.className='mp-modal__x'; x.setAttribute('aria-label','Schliessen'); x.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      box.appendChild(x); box.appendChild(c); m.appendChild(box); document.body.appendChild(m); document.documentElement.style.overflow='hidden';
      specs(m);
      function close(){m.remove();document.documentElement.style.overflow=''}
      x.addEventListener('click',close); m.addEventListener('click',function(ev){if(ev.target===m)close()});
      document.addEventListener('keydown',function k(ev){if(ev.key==='Escape'){close();document.removeEventListener('keydown',k)}});
    });
  }
  function all(r){masseModal();gallery();reveal(r);carousels(r);swatches(r);specs(r);videos(r)}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',function(){all()});
  document.addEventListener('shopify:section:load',function(e){all(e.target)});
})();
